<template>
    <div id="browseRecords">
        <Header :title="title" />

        <template v-if="app.template.type === '92fanli'">
            <NTfanliFavoriteFilter :style-name="app.template.style" :tab-index="tabIndex"
                                   v-on:changeTabIndex="typeListTab" />
            <NTfanliBrowseRecords :style-name="app.template.style" :tab-index="tabIndex"
                                  :list="goodsList" />
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <DamaiFavoriteFilter :style-name="app.template.style" :tab-index="tabIndex"
                                 v-on:changeTabIndex="typeListTab" />
            <DamaiBrowseRecords :style-name="app.template.style" :tab-index="tabIndex"
                                :list="goodsList" />
        </template>
        <template v-else>
            <IfanliFavoriteFilter :style-name="app.template.style" :tab-index="tabIndex"
                                  v-on:changeTabIndex="typeListTab" />
            <IfanliBrowseRecords :style-name="app.template.style" :tab-index="tabIndex"
                                 :list="goodsList" />
        </template>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import IfanliFavoriteFilter from './ifanli/FavoriteFilter';
    import NTfanliFavoriteFilter from './92fanli/FavoriteFilter';
    import DamaiFavoriteFilter from './damai/FavoriteFilter';
    import IfanliBrowseRecords from './ifanli/BrowseRecords';
    import NTfanliBrowseRecords from './92fanli/BrowseRecords';
    import DamaiBrowseRecords from './damai/BrowseRecords';
    import Header from '../components/Header';
    import {isMobile} from '../libs/utils';

    const store2 = require('store2')

    export default {
        components: {
            IfanliFavoriteFilter,
            IfanliBrowseRecords,
            NTfanliFavoriteFilter,
            NTfanliBrowseRecords,
            DamaiFavoriteFilter,
            DamaiBrowseRecords,
            Header
        },
        data() {
            return {
                title: '我的浏览',
                tabIndex: 1,
                goodsList: []
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin + '/user';
            }
            this.fetchGoodsList();
        },
        methods: {
            typeListTab: function (index) {
                this.tabIndex = index;
                this.fetchGoodsList();
            },
            fetchGoodsList: function () {
                this.goodsList = [];
                if (this.tabIndex === 2) {
                    if (store2.has('jdBrowseRecords')) this.goodsList = JSON.parse(store2.get('jdBrowseRecords'));
                } else if (this.tabIndex === 3) {
                    if (store2.has('pddBrowseRecords')) this.goodsList = JSON.parse(store2.get('pddBrowseRecords'));
                } else {
                    if (store2.has('topBrowseRecords')) this.goodsList = JSON.parse(store2.get('topBrowseRecords'));
                }
            },
        }
    }
</script>

<style scoped>

</style>
